import { useEffect } from "react";
import type { NarrativeMetadata } from "../types/narrative";

const DEFAULT_TITLE = "/Forward - AI for quick reports";

/**
 * Updates document.title based on narrative metadata.
 * Uses shareTitle if available, falls back to customer_name, then default.
 *
 * @param metadata - Narrative metadata (optional, resets to default if null/undefined)
 */
export function useDocumentMeta(metadata?: NarrativeMetadata | null): void {
  useEffect(() => {
    if (!metadata) {
      document.title = DEFAULT_TITLE;
      return;
    }

    const displayTitle = metadata.shareTitle || metadata.customer_name;
    document.title = displayTitle
      ? `/Forward - ${displayTitle}`
      : DEFAULT_TITLE;

    // Cleanup: reset to default when component unmounts
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [metadata]);
}
